import { useContext } from 'react'
import classNames from 'classnames'

import { Select, Message } from '@arco-design/web-react'
import { GlobalContext } from '@/context'
import localeSwitch from '@/locale/localeSwitch'
import ArrowDownFilling from '@/assets/arrow-down-filling.svg'
import { Language } from '@/utils/language'
import { setCookie } from 'cookies-next'
import styles from './style/index.module.less'
import { COOKIE_EXPIRE_TIME, LANG_COOKIE } from '@/utils/constants'

export interface IProps {
  theme?: string
  getPopupContainer?: () => Element
}

export const langOptions = [
  { label: 'English', value: Language.enUS, englishName: 'english', currency: 'USD' },
  { label: 'Bahasa Indonesia', value: Language.idID, englishName: 'indonesian', currency: 'IDR' },
  { label: '中文', value: Language.zhCN, englishName: 'chinese', currency: 'CNY' },
  { label: 'ภาษาไทย', value: Language.thTH, englishName: 'thai', currency: 'THB' },
  { label: 'Bahasa Melayu', value: Language.msMY, englishName: 'malay', currency: 'MYR' },
  { label: 'Español', value: Language.esES, englishName: 'spanish', currency: 'EUR' }
]

function LanguageSwitch({ theme = 'dark', getPopupContainer }: IProps) {
  const { lang } = useContext(GlobalContext)

  return (
    <div
      className={classNames(styles.container, {
        [styles.dark]: theme === 'dark',
        [styles.light]: theme === 'light'
      })}
    >
      <Select
        {...(theme === 'dark' && {
          arrowIcon: <ArrowDownFilling />
        })}
        options={langOptions}
        value={lang}
        triggerProps={{
          className: styles.popup,
          autoAlignPopupWidth: false,
          autoAlignPopupMinWidth: true,
          position: 'br'
        }}
        getPopupContainer={getPopupContainer}
        trigger="hover"
        onChange={(value: Language) => {
          setCookie(LANG_COOKIE, value, { maxAge: COOKIE_EXPIRE_TIME })

          const nextLang = localeSwitch[value]
          const curLabel = langOptions.find((item) => item.value === value)?.label
          Message.info(`${nextLang['message.lang.tips']}${curLabel}`)
          window.location.reload()
        }}
      />
    </div>
  )
}

export default LanguageSwitch
